// /* ==================================================================
//    North Shore Peptides — Deterministic ratings
//    A product's rating (4, 4.5 or 5) and review count (100–312) are
//    derived from a stable hash of its handle, so they never change
//    between loads and match everywhere the product appears.
//    Exposes window.NP for the product reviews section to reuse.
//    ================================================================== */
// (function () {
//   'use strict';

//   // djb2 string hash → always positive integer
//   function hash(str) {
//     var h = 5381;
//     str = String(str || '');
//     for (var i = 0; i < str.length; i++) {
//       h = ((h << 5) + h + str.charCodeAt(i)) | 0;
//     }
//     return Math.abs(h);
//   }

//   // Deterministic { rating, count } for a product handle
//   function rating(handle) {
//     var h = hash(handle);
//     var scale = [4, 4.5, 5];
//     return {
//       rating: scale[h % 3],
//       count: 100 + (h % 213) // 100–312 inclusive
//     };
//   }

//   // One shared linearGradient for half stars (inserted once)
//   function ensureGradient() {
//     if (document.getElementById('np-star-defs')) return;
//     var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
//     svg.setAttribute('id', 'np-star-defs');
//     svg.setAttribute('width', '0');
//     svg.setAttribute('height', '0');
//     svg.setAttribute('aria-hidden', 'true');
//     svg.style.position = 'absolute';
//     svg.innerHTML =
//       '<defs><linearGradient id="np-star-half"><stop offset="50%" stop-color="var(--np-star)"/>' +
//       '<stop offset="50%" stop-color="var(--np-star-empty)"/></linearGradient></defs>';
//     document.body.appendChild(svg);
//   }

//   var STAR_PATH = 'M12 2.6l2.6 5.9 6.4.6-4.8 4.3 1.4 6.3L12 16.9 6.4 19.7l1.4-6.3L3 9.1l6.4-.6z';

//   // type: 'full' | 'half' | 'empty'  — always includes base class np-star
//   function star(type) {
//     var fill = type === 'full' ? 'var(--np-star)' : type === 'half' ? 'url(#np-star-half)' : 'var(--np-star-empty)';
//     return '<svg class="np-star" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="' + fill + '" d="' + STAR_PATH + '"/></svg>';
//   }

//   function starsHTML(value) {
//     var full = Math.floor(value);
//     var half = value % 1 >= 0.5 ? 1 : 0;
//     var empty = 5 - full - half;
//     var out = '';
//     for (var i = 0; i < full; i++) out += star('full');
//     if (half) out += star('half');
//     for (var j = 0; j < empty; j++) out += star('empty');
//     return '<span class="np-stars" role="img" aria-label="' + value + ' out of 5 stars">' + out + '</span>';
//   }

//   // Fill a placeholder element: <span data-np-rating data-handle="..." [data-count] [data-count-label] [data-show-value]>
//   function render(el) {
//     if (el.dataset.npRatingDone === '1') return;
//     var handle = el.dataset.handle;
//     if (!handle) return;
//     var r = rating(handle);
//     var html = '';
//     if (el.hasAttribute('data-show-value')) {
//       html += '<span class="np-rating-value">' + r.rating.toFixed(1) + '</span>';
//     }
//     html += starsHTML(r.rating);
//     if (el.hasAttribute('data-count')) {
//       var label = el.dataset.countLabel;
//       html += '<span class="np-rating-count">' + (label ? r.count + ' ' + label : '(' + r.count + ')') + '</span>';
//     }
//     el.innerHTML = html;
//     el.dataset.npRatingDone = '1';
//   }

//   function renderAll(root) {
//     ensureGradient();
//     (root || document).querySelectorAll('[data-np-rating]').forEach(render);
//   }

//   // Public API for the reviews section (same source of truth)
//   window.NP = window.NP || {};
//   window.NP.hash = hash;
//   window.NP.rating = rating;
//   window.NP.starsHTML = starsHTML;
//   window.NP.renderRatings = renderAll;

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', function () { renderAll(); });
//   } else {
//     renderAll();
//   }
//   document.addEventListener('shopify:section:load', function (e) { renderAll(e.target); });
// })();



/* ==================================================================
   North Shore Peptides — Deterministic ratings

   A product's rating (4.5–5.0) and review count (30–90) are
   derived from a stable hash of its handle, so they never change
   between loads.

   Allowed ratings:
   4.5, 4.6, 4.7, 4.8, 4.9, 5.0

   Review count:
   30–90

   Partial stars support the exact decimal:
   4.5 = 50%
   4.6 = 60%
   4.7 = 70%
   4.8 = 80%
   4.9 = 90%
   5.0 = five full stars

   Exposes window.NP for the product reviews section to reuse.
   ================================================================== */

(function () {
  'use strict';

  /* ---------------------------------------------------------------
     Stable handle hash
     --------------------------------------------------------------- */

  function hash(str) {
    var h = 5381;

    str = String(str || '');

    for (var i = 0; i < str.length; i++) {
      h = ((h << 5) + h + str.charCodeAt(i)) | 0;
    }

    return Math.abs(h);
  }


  /* ---------------------------------------------------------------
     Deterministic rating + review count

     Rating:
     4.5 / 4.6 / 4.7 / 4.8 / 4.9 / 5.0

     Count:
     30–90
     --------------------------------------------------------------- */

  function rating(handle) {
    var h = hash(handle);

    var ratingX10 = 45 + (h % 6);

    return {
      rating: ratingX10 / 10,
      count: 30 + (h % 61)
    };
  }


  /* ---------------------------------------------------------------
     Shared SVG gradients

     Creates:
     np-star-10
     np-star-20
     ...
     np-star-90

     This allows exact fractional stars instead of only half stars.
     --------------------------------------------------------------- */

  function ensureGradients() {
    if (document.getElementById('np-star-defs')) {
      return;
    }

    var svg = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'svg'
    );

    svg.setAttribute('id', 'np-star-defs');
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');
    svg.setAttribute('aria-hidden', 'true');

    svg.style.position = 'absolute';
    svg.style.width = '0';
    svg.style.height = '0';
    svg.style.overflow = 'hidden';

    var defs = '<defs>';

    for (var pct = 10; pct <= 90; pct += 10) {
      defs +=
        '<linearGradient id="np-star-' + pct + '">' +

          '<stop offset="' + pct + '%" ' +
          'stop-color="var(--np-star)"/>' +

          '<stop offset="' + pct + '%" ' +
          'stop-color="var(--np-star-empty)"/>' +

        '</linearGradient>';
    }

    defs += '</defs>';

    svg.innerHTML = defs;

    document.body.appendChild(svg);
  }


  /* ---------------------------------------------------------------
     Star SVG
     --------------------------------------------------------------- */

  var STAR_PATH =
    'M12 2.6l2.6 5.9 6.4.6-4.8 4.3 1.4 6.3L12 16.9 6.4 19.7l1.4-6.3L3 9.1l6.4-.6z';


  /*
    type:
    full
    partial
    empty

    percentage:
    10–90 when type === partial
  */

  function star(type, percentage) {
    var fill;

    if (type === 'full') {
      fill = 'var(--np-star)';
    }

    else if (type === 'partial') {
      fill = 'url(#np-star-' + percentage + ')';
    }

    else {
      fill = 'var(--np-star-empty)';
    }


    return (
      '<svg ' +
        'class="np-star" ' +
        'viewBox="0 0 24 24" ' +
        'aria-hidden="true" ' +
        'focusable="false">' +

        '<path ' +
          'fill="' + fill + '" ' +
          'd="' + STAR_PATH + '"/>' +

      '</svg>'
    );
  }


  /* ---------------------------------------------------------------
     Generate stars

     Examples:

     4.5
     ★ ★ ★ ★ 50%

     4.6
     ★ ★ ★ ★ 60%

     4.9
     ★ ★ ★ ★ 90%

     5.0
     ★ ★ ★ ★ ★
     --------------------------------------------------------------- */

  function starsHTML(value) {
    value = Number(value) || 0;

    var ratingX10 = Math.round(value * 10);

    var full = Math.floor(ratingX10 / 10);

    var decimal = ratingX10 % 10;

    var partialPercent = decimal * 10;

    var hasPartial = partialPercent > 0;

    var empty = 5 - full - (hasPartial ? 1 : 0);

    var out = '';


    /* Full stars */

    for (var i = 0; i < full; i++) {
      out += star('full');
    }


    /* Exact partial star */

    if (hasPartial) {
      out += star(
        'partial',
        partialPercent
      );
    }


    /* Empty stars */

    for (var j = 0; j < empty; j++) {
      out += star('empty');
    }


    return (
      '<span ' +
        'class="np-stars" ' +
        'role="img" ' +
        'aria-label="' + value.toFixed(1) + ' out of 5 stars">' +

        out +

      '</span>'
    );
  }


  /* ---------------------------------------------------------------
     Render rating placeholder

     Example:

     <span
       data-np-rating
       data-handle="bpc-157"
       data-count
       data-show-value>
     </span>
     --------------------------------------------------------------- */

  function render(el) {

    if (el.dataset.npRatingDone === '1') {
      return;
    }


    var handle = el.dataset.handle;

    if (!handle) {
      return;
    }


    var r = rating(handle);

    var html = '';


    /* Rating number */

    if (el.hasAttribute('data-show-value')) {

      html +=
        '<span class="np-rating-value">' +
          r.rating.toFixed(1) +
        '</span>';

    }


    /* Stars */

    html += starsHTML(r.rating);


    /* Review count */

    if (el.hasAttribute('data-count')) {

      var label = el.dataset.countLabel;

      if (label) {

        html +=
          '<span class="np-rating-count">' +
            r.count +
            ' ' +
            label +
          '</span>';

      }

      else {

        html +=
          '<span class="np-rating-count">' +
            '(' + r.count + ')' +
          '</span>';

      }

    }


    el.innerHTML = html;

    el.dataset.npRatingDone = '1';
  }


  /* ---------------------------------------------------------------
     Render all ratings
     --------------------------------------------------------------- */

  function renderAll(root) {

    ensureGradients();

    var container = root || document;

    container
      .querySelectorAll('[data-np-rating]')
      .forEach(render);
  }


  /* ---------------------------------------------------------------
     Public API

     window.NP.rating('bpc-157')

     returns:

     {
       rating: 4.8,
       count: 57
     }
     --------------------------------------------------------------- */

  window.NP = window.NP || {};

  window.NP.hash = hash;

  window.NP.rating = rating;

  window.NP.starsHTML = starsHTML;

  window.NP.renderRatings = renderAll;


  /* ---------------------------------------------------------------
     Initial render
     --------------------------------------------------------------- */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      function () {
        renderAll();
      }
    );

  }

  else {

    renderAll();

  }


  /* ---------------------------------------------------------------
     Shopify Theme Editor section reload
     --------------------------------------------------------------- */

  document.addEventListener(
    'shopify:section:load',
    function (e) {
      renderAll(e.target);
    }
  );

})();